export class MUser {
  DisplayText?: string;
  Id: string = '';
  ParentId: string = '';
  EMail?: string;
  Login?: string;
  LoginMode?: number;
  MaxSessionsCount?: number;
  MinSessionsCount?: number;
  Name: string = '';
  PasswordHash?: string;

  constructor(data: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}
